import React, { Component } from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    CardText,
    CardFooter,
    Row,
    Col
} from "reactstrap";
import DocumentUpload from '../components/DocumentUpload';
import { connect } from 'react-redux';
import moment from 'moment';
import { LeadService, ServiceUtil, metadataService } from "../_services/";
import { newLoanActions } from "../_actions";
import { SlBusyIndicator } from "./editors";

class UploadDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leadByToken: {},
            didMount: false,
            contactNumber: '',
            documents: []
        };

        this.handleTokenValidationFailure = this.handleTokenValidationFailure.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
    }

    componentDidMount() {
        

        if (this.props.hash) {
            LeadService.isValidToken(this.props.hash).then(result => {
                const leadByToken = result.data;

                if (leadByToken.isValid) {
                    const newState = {
                        leadByToken: leadByToken
                    }

                    this.handleSetState(newState);

                    let serviceUrl = 'api/Document/Lead/' + leadByToken.leadId + '/Status';
                    ServiceUtil.executeServiceCall('DocumentAPI', serviceUrl , ServiceUtil.getRequest())
                        .then(r => {
                            const newState = {
                                didMount: true
                            }

                            if (r.data.length > 0) {
                                newState.documents = r.data;
                            }

                            this.handleSetState(newState);
                        });
                }
                else {
                    this.handleTokenValidationFailure();
                }
            });
        }
        else {
            this.handleTokenValidationFailure();
        }
    }

    handleSetState(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        this.setState(stateChanges);
    }

    handleTokenValidationFailure = () => {
        const { dispatch } = this.props;

        dispatch(newLoanActions.tokenValidationFailure("Error 404: Not Found."));
    }

    getDisplayStatus(document) {
        if (document) {
            if (document.documentStatusId === 3) {
                return `${document.documentStatusText} - ${document.rejectedReason}: ${metadataService.getMessage('PleaseSubmitNewDocument')}`;
            }
            else if (document.documentStatusId === 4) {
                return document.documentStatusText;
            }
            else {
                return "Under Review";
            }
        }
        else {
            return "";
        }
    }

    getDisplayStatusClass(document) {
        if (document && document.documentStatusId === 3) {
            return 'RejectedStatus';
        }
        else {
            return "UploadStatus";
        }
    }

    render() {
        let { firstName, lastName, applicationNumber, leadId } = this.state.leadByToken;
        let origin = this.state.leadByToken.phone ? this.state.leadByToken.phone : this.state.leadByToken.email;

        let documentClassifications = metadataService.getLookup("documentClassifications");
        let frontId = documentClassifications.find(d => d.text === "IdentityFront");
        let backId = documentClassifications.find(d => d.text === "IdentityBack");
        let residenceId = documentClassifications.find(d => d.text === "Residence");
        let incomeId = documentClassifications.find(d => d.text === "Income");

        let identityFront = this.state.documents.find(x => x.documentClassificationId === frontId.value);
        let identityBack = this.state.documents.find(x => x.documentClassificationId === backId.value);
        let residence = this.state.documents.find(x => x.documentClassificationId === residenceId.value);
        let income = this.state.documents.find(x => x.documentClassificationId === incomeId.value);

        let zeroValue = '0001-01-01 00:00:00.0000000 +00:00';

        return (
            <div>

                {this.state.didMount && (
                    <Card className={"text-center"}>
                        <CardTitle>
                            Welcome, {firstName} {lastName}
                        </CardTitle>
                        <CardTitle>
                            Application #{applicationNumber}
                        </CardTitle>
                        <CardText>
                            Upload your documents below or take a picture on your cell phone and text the documents to {this.props.contactNumber} so we can continue processing your application
                        </CardText>
                        <CardBody>
                            <Row>
                                <DocumentUpload
                                    uploadTitle={"Proof of Identity Front"}
                                    leadId={leadId}
                                    origin={origin}
                                    documentStatus={this.getDisplayStatus(identityFront)}
                                    documentStatusClass={this.getDisplayStatusClass(identityFront)}
                                    documentClassification={frontId.value}
                                    hideDropZone={!!identityFront && identityFront.documentStatusId !== 3}
                                    lastModified={identityFront ? moment((identityFront.modifiedTime === zeroValue ? identityFront.modifiedTime : identityFront.creationTime)).format('M/DD/yyyy h:mm a') : ''}
                                />
                            </Row>
                            <Row>
                                <DocumentUpload
                                    uploadTitle={"Proof of Identity Back"}
                                    leadId={leadId}
                                    origin={origin}
                                    documentStatus={this.getDisplayStatus(identityBack)}
                                    documentStatusClass={this.getDisplayStatusClass(identityBack)}
                                    documentClassification={backId.value}
                                    hideDropZone={!!identityBack && identityBack.documentStatusId !== 3}
                                    lastModified={identityBack ? (moment((identityBack.modifiedTime === zeroValue ? identityBack.modifiedTime : identityBack.creationTime)).format('M/DD/yyyy h:mm a')) : ''}
                                />
                            </Row>
                            <Row>
                                <DocumentUpload
                                    uploadTitle={"Proof of Residence"}
                                    leadId={leadId}
                                    origin={origin}
                                    documentStatus={this.getDisplayStatus(residence)}
                                    documentStatusClass={this.getDisplayStatusClass(residence)}
                                    documentClassification={residenceId.value}
                                    hideDropZone={!!residence && residence.documentStatusId !== 3}
                                    lastModified={residence ? (moment(residence.modifiedTime === zeroValue ? residence.modifiedTime : residence.creationTime).format('M/DD/yyyy h:mm a')) : ''}
                                />
                            </Row>
                            <Row>
                                <DocumentUpload
                                    uploadTitle={"Proof of Income"}
                                    leadId={leadId}
                                    origin={origin}
                                    documentStatus={this.getDisplayStatus(income)}
                                    documentStatusClass={this.getDisplayStatusClass(income)}
                                    documentClassification={incomeId.value}
                                    hideDropZone={!!income && income.documentStatusId !== 3}
                                    lastModified={income ? (moment(income.modifiedTime === zeroValue ? income.modifiedTime : income.creationTime).format('M/DD/yyyy h:mm a')) : ''}
                                />
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <h1>{this.props.contactNumber}</h1>
                        </CardFooter>
                    </Card>
                )}

                {!this.state.didMount && (
                    <SlBusyIndicator visible={!this.state.didMount} />
                )}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { hash } = ownProps.match.params;
    const {supportInfo} = state.configuration
    return {
        hash: hash,
        contactNumber : supportInfo && supportInfo.leadContactNumber ? supportInfo.leadContactNumber : "",
    };
}

export default connect(mapStateToProps)(UploadDocuments)

